import { render, staticRenderFns } from "./DadosInscricao.vue?vue&type=template&id=39e9ccf6"
import script from "./DadosInscricao.vue?vue&type=script&lang=js"
export * from "./DadosInscricao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports